// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2kr3M","title":"styles_title__a_4rm"};